import { BaseComponent } from '../../base-component';

export class HideBorderIfEmptyComponent extends BaseComponent {
    public rootSelector = '';

    public async onHtmlLoaded(): Promise<void> {
        this.watchHiddenElements();
    }

    private watchHiddenElements() {
        this.getElementsThatShouldBeHidden()?.forEach(async el => {
            await this.observeTarget(el);
        });
    }

    private async observeTarget(targetElement: HTMLElement): Promise<void> {
        const config = { childList: true, subtree: true };
        const callback = async () => {
            await this.showOrHideElement(targetElement);
        };

        /*                                      */
        await this.showOrHideElement(targetElement);

        const observer = new MutationObserver(callback);
        observer.observe(targetElement, config);
    }

    private showOrHideElement(el: HTMLElement) {
        this.showBorder(el);

        if (!this.hasContent(el)) {
            this.hideBorder(el);
        }
    }

    private hasContent(element: HTMLElement): boolean {
        return !!element.innerHTML?.trim().length && element.clientHeight > 5;
    }

    private getElementsThatShouldBeHidden(): NodeListOf<HTMLElement> {
        return document.querySelectorAll<HTMLElement>('[data-hide-border-if-empty]');
    }

    private showBorder(el: HTMLElement) {
        el.classList.remove('hide-border-if-empty');
    }

    private hideBorder(el: HTMLElement) {
        if (!el.classList.contains('hide-border-if-empty')) {
            el.classList.add('hide-border-if-empty');
        }
    }
}
